import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1017345c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "container" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "grid-container" }
const _hoisted_6 = { class: "grid-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-item-header" }, "Legal Entity", -1))
const _hoisted_8 = { class: "content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Legal Name", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Legal Form", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Zuständigkeitsbereich", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Business Registry Identifier", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Entity status", -1))
const _hoisted_14 = { class: "grid-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-item-header" }, "Legal Adresse", -1))
const _hoisted_16 = { class: "content" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Straße", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Postleitzahl", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Stadt", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Region", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Land", -1))
const _hoisted_22 = { class: "grid-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-item-header" }, "Haupsitz Adresse", -1))
const _hoisted_24 = { class: "content" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Straße", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "PLZ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Stadt", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Region", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Land", -1))
const _hoisted_30 = { class: "grid-item" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-item-header" }, "Registrationsdetails", -1))
const _hoisted_32 = { class: "content" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "LEI", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Registration Status", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Initial Status", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Nächste Verlängerung", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Letztes Update", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Managing", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Validation Quellen", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.lei.registrationDetails.lei), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.StringUtil.capitalizeFirstLetter(_ctx.backUri)) + " • " + _toDisplayString(_ctx.lei.legalEntity.legalName), 1)
      ]),
      _createElementVNode("h1", null, _toDisplayString(_ctx.lei.legalEntity.legalName), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_base_button, {
          title: 'Zurück',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back()))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.legalEntity.legalName), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.legalEntity.legalForm), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.legalEntity.jurisdiction), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_12,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.legalEntity.businessRegistryIdentifier), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_13,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.legalEntity.status), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("table", _hoisted_16, [
          _createElementVNode("tr", null, [
            _hoisted_17,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.legalAddress.street), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_18,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.legalAddress.postalCode), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_19,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.legalAddress.city), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_20,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.legalAddress.region), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_21,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.legalAddress.country), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("table", _hoisted_24, [
          _createElementVNode("tr", null, [
            _hoisted_25,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.headquartersAddress.street), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_26,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.headquartersAddress.postalCode), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_27,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.headquartersAddress.city), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_28,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.headquartersAddress.region), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_29,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.headquartersAddress.country), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("table", _hoisted_32, [
          _createElementVNode("tr", null, [
            _hoisted_33,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.registrationDetails.lei), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_34,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.registrationDetails.status), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_35,
            _createElementVNode("td", null, _toDisplayString(_ctx.StringUtil.formatDate(_ctx.lei.registrationDetails.initialStatus)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_36,
            _createElementVNode("td", null, _toDisplayString(_ctx.StringUtil.formatDate(_ctx.lei.registrationDetails.nextRenewal)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_37,
            _createElementVNode("td", null, _toDisplayString(_ctx.StringUtil.formatDate(_ctx.lei.registrationDetails.lastUpdate)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_38,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.registrationDetails.managing), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_39,
            _createElementVNode("td", null, _toDisplayString(_ctx.lei.registrationDetails.validationSources), 1)
          ])
        ])
      ])
    ])
  ]))
}